<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Filter :button="filterConfig.buttonConfig" />

    <div class="table-data">
      <table class="table table-hover table-responsive">
        <thead class="table-light">
          <tr>
            <th scope="col" width="30">
              <span class="d-flex justify-content-start">
              </span>

            </th>
            <th scope="col" width="140">ID</th>
            <th scope="col" width="180">Title</th>
            <th scope="col" width="180">Sensor Type</th>
            <th scope="col" width="120">Device</th>
            <th scope="col" width="110">Tag Number</th>
            <th scope="col">Meter Type</th>
            <th scope="col" style="white-space: nowrap;">OP Temp </th>
            <th scope="col">Alarm</th>
            <th scope="col">
              <span class="d-flex justify-content-end">
                <tableHeadingIcon />
              </span>

            </th>

          </tr>
        </thead>
        <tbody v-for="(item, index) in tableData" :key="index">
          <tr>
            <td rowspan="2">
              <span class="d-flex justify-content-start">
                <button class="custom-dropdown-icon" @click="toggleCollapse(index)">
                  <svg v-if="isCollapsed[index]" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg>
                </button>
              </span>
            </td>
            <td>{{ item.id }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.sensortypetitle }}</td>
            <td>{{ item.devicetitle }}</td>
            <td>{{ item.physicalid }}</td>
            <td >{{item.metertype }} </td>
            <td>{{ item.optemp }}</td>
            <td v-if="item.isalarm === 0">Off</td>
            <td v-else>On</td>
            <td>
              <span class="d-flex justify-content-end">
                <router-link :to="`/iotsensors/sensor/edit/${item.uuid}`">
                  <editIcon />
                </router-link>
              </span>

            </td>

          </tr>
          <tr v-if="isCollapsed[index]">
            <td colspan="10" class="py-0 px-0">
              <table class="table table-responsive sub-table mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" width="150">Auto Manage</th>
                    <th scope="col" width="150">Low Cutoff</th>
                    <th scope="col" width="150">High Cutoff</th>
                    <th scope="col" width="150">Max Flow Rate</th>
                    <th scope="col" width="180">Flow Rate Unit</th>
                    <th scope="col" width="120">Total</th>
                    <th scope="col">Total Unit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td v-if="item.isautomanage === 1">On</td>
                    <td v-else>Off</td>
                    <td>{{ item.lowcuttoff }}%</td>
                    <td>{{ item.highcuttoff }}%</td>
                    <td>{{ item.flowrate }}</td>
                    <td>{{ item.flowrateunit }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.totalunit }}</td>

                  </tr>
                </tbody>
              </table>
              <table class="table table-responsive sub-table mb-0">
                <thead class="table-light">
                  <tr>

                    <th scope="col" width="150">Flow Coefficient</th>
                    <th scope="col" width="150">Flow Medium</th>
                    <th scope="col" width="150">Meter Factor</th>
                    <th scope="col" width="150">Full Scale Flow</th>
                    <th scope="col" width="180"> Date and Time</th>
                    <th scope="col" width="120">Address</th>
                    <th scope="col">Boud Rate</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td>{{ item.flowcofficient }}</td>
                    <td>{{ item.flow_medium }}</td>
                    <td>{{ item.meterfactor }}</td>
                    <td>{{ item.fullscaleflow }}</td>
                    <td>{{ item.dateandtime }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.boudrate }}</td>

                  </tr>
                </tbody>
              </table>
              <table class="table table-responsive sub-table mb-0">
                <thead class="table-light">
                  <tr>

                    <th scope="col" width="150">Density</th>
                    <th scope="col" width="150">Zero Volt</th>
                    <th scope="col" width="150">Equivalent ID</th>
                    <th scope="col" width="150">Resistance Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td>{{ item.density }}</td>
                    <td>{{ item.zerovolt }}</td>
                    <td>{{ item.equivalentid }}</td>
                    <td>{{ item.resistancevalue }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination-container">
        <div class="items-per-page">
          <label for="itemsPerPage">Records Per Page:</label>
          <select id="itemsPerPage" class="items-per-page-dropdown" v-model="pageSize" @change="changePageSize">
            <option v-for="option in pageSizeOptions" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="total-entries">
          <span>Total Records: {{ totalCount }}</span>
        </div>
        <div class="pagination">
          <ul class="pagination-list">
            <li @click="gotoPage(1)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-start-fill" viewBox="0 0 16 16">
                  <path
                    d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" />
                </svg></a></li>
            <li @click="prevPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                </svg></a></li>
            <li v-for="pageNumber in visiblePages" :key="pageNumber" :class="{ active: pageNumber === currentPage }"
              class="ellipsis-icon" @click="gotoPage(pageNumber)">
              <template v-if="pageNumber === 'dots'">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-three-dots" viewBox="0 0 16 16">
                    <path
                      d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                  </svg>
                </span>
              </template>
              <template v-else>
                <a>{{ pageNumber }}</a>
              </template>
            </li>

            <li @click="nextPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                </svg></a></li>
            <li @click="gotoPage(totalPages)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-end-fill" viewBox="0 0 16 16">
                  <path
                    d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" />
                </svg></a></li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import editIcon from '@/components/edit-icon.vue';
import tableHeadingIcon from '@/components/table-heading-icon.vue';
import { getSensor } from "@/http/iot-sensors/sensor.http"
export default {
  name: "sensor",
  components: {
    Header,
    Filter,
    editIcon,
    tableHeadingIcon
  },
  data() {
    return {
      breadcrumsfirst: "IoT Sensors",
      breadcrumslast: "Sensor",
      filterConfig: {
        buttonConfig: {
          show: true,
          link: '/iotsensors/sensor/add'
        }
      },
      tableData: [],
      isCollapsed: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      pageSizeOptions: [10, 20], // Define your options for items per page
    };
  },
  created() {
    // Initialize isCollapsed with the correct length and set all elements to false
    this.isCollapsed = new Array(this.tableData.length).fill(false);
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
    visiblePages() {
      const totalVisiblePages = 3; // Change this as needed
      const pages = [];
      let startPage = 1;
      let endPage = this.totalPages;

      if (this.totalPages > totalVisiblePages) {
        const halfVisiblePages = Math.floor(totalVisiblePages / 2);
        startPage = Math.max(this.currentPage - halfVisiblePages, 1);
        endPage = startPage + totalVisiblePages - 1;

        if (endPage > this.totalPages) {
          startPage -= endPage - this.totalPages;
          endPage = this.totalPages;
        }

        if (startPage > 1) {
          pages.push(1);
          if (startPage > 2) {
            pages.push('dots');
          }
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < this.totalPages) {
        if (endPage < this.totalPages - 1) {
          pages.push('dots');
        }
        pages.push(this.totalPages);
      }

      return pages;
    }
  },
  methods: {
    fetchData() {
      getSensor({
        index: this.currentPage,
        pagesize: this.pageSize
      })
        .then(response => {
          // const thermalmassFlowMeter = response.thermalmass_flow_meter || [];
          // const averagingPitotTube = response.averaging_pitot_tube || [];
          // const sensorData = [...thermalmassFlowMeter, ...averagingPitotTube];

          this.tableData = response.data;
          this.totalCount = response.recordcount.totalcount;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    gotoPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
        this.fetchData();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchData();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchData();
      }
    },
    changePageSize() {
      this.currentPage = 1; // Reset to the first page when changing page size
      this.fetchData();
    },
    toggleCollapse(index) {
      this.isCollapsed[index] = !this.isCollapsed[index];
    }
  },
  mounted() {
    this.fetchData();
  }

};
</script>

<style>
.sub-table {
  border: transparent;
}

.custom-dropdown-icon {
  border: none;
  /* Remove the border */
  background: none;
  /* Remove background */
  cursor: pointer;
  /* Change cursor to pointer on hover */
  padding: 0;
  /* Remove padding */
  margin: 0;
  /* Remove margin */
}
</style>